'use client';

import Image from 'next/image';
import Link from 'next/link';
import { useRouter } from 'next/navigation';
import { useState, useTransition } from 'react';
import { toast } from 'sonner';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Spinner } from '@/components/ui/spinner';
import { PENDING_LOGIN_STORAGE_KEY } from '@/core/analytics/posthog/utils/constants';
import { login } from '@/core/authorizations/server/actions/login';
import { PasswordInput } from './password-input';
export const LoginForm = ({
  redirectUrl = '/admin'
}: {
  redirectUrl?: string;
}) => {
  const [isPending, startTransition] = useTransition();
  const router = useRouter();
  const [showPassword, setShowPassword] = useState(false);
  const handleFormSubmit = async (formData: FormData) => {
    startTransition(async () => {
      const {
        success,
        message
      } = await login(formData);
      if (success === true) {
        sessionStorage.setItem(PENDING_LOGIN_STORAGE_KEY, '1');
        router.replace(redirectUrl);
      } else {
        toast.error('Erreur', {
          description: message
        });
      }
    });
  };
  return <Card className="w-full" data-sentry-element="Card" data-sentry-component="LoginForm" data-sentry-source-file="login-form.tsx">
      <CardHeader data-sentry-element="CardHeader" data-sentry-source-file="login-form.tsx">
        <div className="flex w-full justify-center">
          <Image src="/logo-text.svg" width={148} height={41} alt="enrise logo" className="h-auto w-32 sm:w-40" priority data-sentry-element="Image" data-sentry-source-file="login-form.tsx" />
        </div>
      </CardHeader>
      <CardContent data-sentry-element="CardContent" data-sentry-source-file="login-form.tsx">
        <form action={handleFormSubmit} className="space-y-6">
          <div className="space-y-2 text-center">
            <h1 className="text-xl font-semibold tracking-tight sm:text-2xl">
              Connexion
            </h1>
          </div>
          <div className="space-y-2">
            <Label htmlFor="email" className="text-sm" data-sentry-element="Label" data-sentry-source-file="login-form.tsx">
              Email
            </Label>
            <Input id="email" name="email" type="email" placeholder="Entrer votre email" required className="w-full" data-sentry-element="Input" data-sentry-source-file="login-form.tsx" />
          </div>
          <PasswordInput id="password" name="password" label="Mot de passe" placeholder="********" showPassword={showPassword} onToggleVisibility={() => setShowPassword(!showPassword)} required data-sentry-element="PasswordInput" data-sentry-source-file="login-form.tsx" />
          <div className="flex items-center justify-end">
            <Link href="/auth/forgot-password" className="text-sm font-medium text-primary hover:underline" data-sentry-element="Link" data-sentry-source-file="login-form.tsx">
              Mot de passe oublié ?
            </Link>
          </div>
          <div className="space-y-4">
            <Button type="submit" variant="primary" className="w-full" disabled={isPending} data-sentry-element="Button" data-sentry-source-file="login-form.tsx">
              {isPending && <Spinner />}
              Se connecter
            </Button>
          </div>
        </form>
      </CardContent>
    </Card>;
};